import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import store from './store'
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'

import localforage from 'localforage'
import VCalendar from 'v-calendar'
Vue.use(VCalendar)


import { abilitiesPlugin } from '@casl/vue';
import ability from '@/config/ability';

Vue.use(abilitiesPlugin, ability);

import VueCurrencyInput from 'vue-currency-input'

Vue.use(VueCurrencyInput)

require('./filter')

import vSelect from 'vue-select'
import OpenIndicator from '@/components/OpenIndicator.vue'
import Deselect from '@/components/Deselect.vue'

vSelect.props.components.default = () => ({
  OpenIndicator: OpenIndicator,
  Deselect: Deselect
})

Vue.component('v-select', vSelect)

localforage.config({
  driver: localforage.LOCALSTORAGE,
  storeName: 'ansolution'
})

Vue.config.productionTip = false

UIkit.use(Icons)
Vue.prototype.$uikit = UIkit

import VueMatomo from 'vue-matomo';
Vue.use(VueMatomo, {
  host: "https://piwik.descpro.de",
  siteId: 68,
  router: router,
  debug: false,
});

import VueCookies from 'vue-cookies'
Vue.use(VueCookies, { expires: '7d'})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
